(function(){
  'use strict';

  angular
    .module('AcaApp')
    .controller('SsnModalController', SsnModalController);

  SsnModalController.$inject = [
    '$mdDialog', 
    'MsgBetweenCtrlService',
    'UtilsService',
    'PARTICIPANT_FORM'
  ];

  function SsnModalController(mdDialog, sharedData, UtilsService, PARTICIPANT_FORM){
    var _this = this;

    /** properties */
    _this.participant = {};
    _this.oldTin = "";
    _this.newTin = "";

    /** methods */
    _this.cancel = _cancel;
    _this.update = _update;

    _activate();

    /** @private */
    function _activate(){
      _this.participant = sharedData.data.participant;
      _this.oldTin = _this.participant.tinWithoutSuffix;
      _this.newTin = _this.participant.tinWithoutSuffix;
    }

    /** @public */
    function _cancel(){
      mdDialog.hide().finally(_show);
    }

    /** @public */
    function _update(){
      _this.participant.tinWithoutSuffix = _this.newTin;
      _this.participant.oldTinWithoutSuffix = _this.oldTin;
      mdDialog.hide().finally(_show);
    }

    /** @private */
    function _show(){
      mdDialog.show({
        preserveScope: true,
        templateUrl: PARTICIPANT_FORM[UtilsService.getTaxYear()],
        parent: angular.element(document.body),
        controller: 'ParticipantController',
        locals: {
          currentParticipant: _this.participant
        }
      });
    }
  }
})();